import { theme } from 'antd';

const { useToken } = theme;

const ResetZoomIcon = ({ color, width = 24, height = 24 }: { color?: string; width?: number; height?: number }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.875 19.5C4.35938 19.5 3.91797 19.3164 3.55078 18.9492C3.18359 18.582 3 18.1406 3 17.625V5.375C3 4.85938 3.18359 4.41797 3.55078 4.05078C3.91797 3.68359 4.35938 3.5 4.875 3.5H19.875C20.3906 3.5 20.832 3.68359 21.1992 4.05078C21.5664 4.41797 21.75 4.85938 21.75 5.375V17.625C21.75 18.1406 21.5664 18.582 21.1992 18.9492C20.832 19.3164 20.3906 19.5 19.875 19.5H4.875ZM19.875 5.375H4.875V17.625H19.875V5.375Z"
        fill={currentColor}
      />
      <path d="M18.5 11.5L14.75 9.33494L14.75 13.6651L18.5 11.5Z" fill={currentColor} />
      <path d="M6.5 11.5L10.25 9.33494L10.25 13.6651L6.5 11.5Z" fill={currentColor} />
    </svg>
  );
};

export default ResetZoomIcon;
